import script from "./DetailCard.vue?vue&type=script&setup=true&lang=js"
export * from "./DetailCard.vue?vue&type=script&setup=true&lang=js"

import "./DetailCard.vue?vue&type=style&index=0&id=4fce5bef&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4fce5bef"]])

export default __exports__